import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { c_dtable_mp_sessions_manager_component } from './c_dtable_mp_sessions_manager.component';
import { SharedModule } from '../../../../../app/directives/shared.module'
import { c_filter_date_range_module } from 'src/3ui/2components/filter/date-picker/c_filter_date_range_module';
import { c_card_mp_session_time_line_module } from 'src/3ui/2components/card/mp-session/c_card_mp_session_time_line.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    c_filter_date_range_module,
    c_card_mp_session_time_line_module
  ],
  declarations: [c_dtable_mp_sessions_manager_component],
  exports: [c_dtable_mp_sessions_manager_component],
})
export class c_dtable_mp_sessions_manager_module { }
